import Api from "../../../app/apiRequest";
import BaseResponse from "../../../app/BaseResponse";
import CargoTypeModel from "../models/CargoTypeModel";

export interface DeleteCargoTypeParam {
    id: number
}

const CargoTypeSelectorApi = {
    GetCargoTypes() {
        return Api.get<null, BaseResponse<CargoTypeModel[]>>("/api/cargo/GetCargoTypes", null);
    },
    SaveCargoType(param: CargoTypeModel) {
        return Api.post<CargoTypeModel, BaseResponse<CargoTypeModel>>("/api/cargo/SaveCargoType", param);
    },
    DeleteCargoType(param: DeleteCargoTypeParam) {
        return Api.post<DeleteCargoTypeParam, BaseResponse<string>>("/api/cargo/DeleteCargoType", param);
    },
};
export default CargoTypeSelectorApi;